export const goTo = (url: string) => window.location.assign(url);

export const redirectTo = (url: string) => window.location.replace(url);
